module.exports = __webpack_public_path__ + "static/veronica-bb5f15ec6a0db52fcf9df927831d5e08.jpg";